import { MEMBERSHIPS } from '../constants/actionTypes';

const initial = { items: [], total: 0, current: null, loading: false, error: null };

export default function membershipReducer(state = initial, action) {
  switch (action.type) {
    case MEMBERSHIPS.LIST_REQUEST: return { ...state, loading: true, error: null };
    case MEMBERSHIPS.LIST_SUCCESS: return { ...state, loading: false, items: action.payload.items, total: action.payload.total };
    case MEMBERSHIPS.LIST_FAILURE: return { ...state, loading: false, error: action.payload };
    case MEMBERSHIPS.GET_SUCCESS:  return { ...state, current: action.payload };
    default: return state;
  }
}
